// extracted by mini-css-extract-plugin
export default {"body":"Body_body__FZmZq","bold":"Body_bold__b5XNQ","medium":"Body_medium__2Mwc9"};